<p-table
  [value]="filteredData"
  [paginator]="paginator"
  [rows]="rows"
  [loading]="loading"
  [style]="{ width: '100%' }"
  responsiveLayout="scroll">

  <ng-template pTemplate="header">
    <tr>
      <th *ngIf="showCheckbox" style="width: 50px;">
        <input type="checkbox" (change)="toggleAllRows($event)" title="Select all rows" [attr.aria-label]="'Select all rows'" />
      </th>
      <th *ngFor="let col of columns" [ngClass]="{'action-column-header': col.type === 'action'}"
            [class.filterable-header]="isFilterable(col)"
            [class.has-filter]="hasFilter(col)">
        <!-- Old PrimeNG sorting disabled - using filter dropdown sorting instead -->
        <!-- [pSortableColumn]="col.sortable !== false && col.type !== 'action' ? col.field : undefined" -->
        <div class="header-content">
          <span class="header-text">{{ col.header }}</span>
          <div class="header-actions">
            <div *ngIf="isFilterable(col)" class="filter-action-wrapper">
              <button
                type="button"
                class="filter-icon-btn"
                [class.active]="openFilterColumn === col.field"
                [class.has-filter]="hasFilter(col)"
                (click)="toggleFilter(col, $event)"
                [attr.aria-label]="'Filter ' + col.header"
                [attr.aria-expanded]="openFilterColumn === col.field"
                #filterButton>
                <i class="bi bi-funnel"></i>
              </button>
            </div>
            <button
              *ngIf="col.type === 'action' && hasAnyFilters()"
              type="button"
              class="clear-all-filters-btn-inline"
              (click)="clearAllFilters()"
              [attr.aria-label]="'Clear all filters'">
              <i class="bi bi-x-circle"></i>
              <span class="clear-filters-text">Clear Filters</span>
            </button>
          </div>
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
    <tr (click)="handleRowClick(row)" [class.selected-row]="isRowSelectedByCallback(row)" [class.disabled-row]="isRowDisabled(row)" [attr.aria-disabled]="isRowDisabled(row)">
      <td *ngIf="showCheckbox" style="width: 50px;">
        <input
          type="checkbox"
          [checked]="isRowSelected(row)"
          [disabled]="isRowDisabled(row)"
          (change)="!isRowDisabled(row) && toggleRowSelection(row, $event)"
          [attr.title]="'Select row ' + (getFieldValue(row, 'evaluationId') || getFieldValue(row, 'id') || (columns[0] && columns[0].field ? getFieldValue(row, columns[0].field) : '') || '')"
          [attr.aria-label]="'Select row ' + (getFieldValue(row, 'evaluationId') || getFieldValue(row, 'id') || (columns[0] && columns[0].field ? getFieldValue(row, columns[0].field) : '') || '')" />
      </td>
      <td *ngFor="let col of columns" [ngClass]="{'firstColumn': col.type === 'link', 'action-column-cell': col.type === 'action'}" [attr.data-current]="col.showCurrentTag && getFieldValue(row, 'isCurrent')">
        <!-- Radio Type -->
        <input
          *ngIf="col.type === 'radio'"
          type="radio"
          [name]="col.radioGroupName || 'selectedRow'"
          [value]="getFieldValue(row, col.field)"
          [checked]="col.isSelected && col.isSelected(row)"
          [disabled]="isRowDisabled(row)"
          (click)="isRowDisabled(row) ? $event.preventDefault() : (col.onSelect && col.onSelect(row, $event))"
          [attr.aria-label]="'Select ' + (col.header || 'row')">

        <!-- Text Type -->
        <span *ngIf="!col.type || col.type === 'text'">
          <div *ngIf="col.showCurrentTag" class="bid-id-cell">
            <span class="bid-id-value">{{ getFieldValue(row, col.field) }}</span>
            <span *ngIf="getFieldValue(row, 'isCurrent')" class="current-tag">Current</span>
          </div>
          <span *ngIf="!col.showCurrentTag">{{ getFieldValue(row, col.field) }}</span>
        </span>

        <!-- Link Type -->
        <a
          *ngIf="col.type === 'link'"
          (click)="handleLinkClick(col.field, row)"
          class="pr-link"
          [class.disabled-link]="isRowDisabled(row)">
          {{ getFieldValue(row, col.field) }}
        </a>

        <!-- Badge Type -->
        <app-status-badge
          *ngIf="col.type === 'badge'"
          [text]="getFieldValue(row, col.field)"
          [color]="getBadgeColor(row, col)"
          [size]="col.badgeSize || 'medium'">
        </app-status-badge>

        <!-- Date Type -->
        <span *ngIf="col.type === 'date'">
          {{ getFieldValue(row, col.field) | date: (col.format || 'dd/MM/yyyy') }}
        </span>

        <!-- Number Type -->
        <span *ngIf="col.type === 'number'">
          {{ getFieldValue(row, col.field) | number: (col.format || '1.0-0') }}
        </span>

        <!-- Linked Tender Type - Custom two-line display -->
        <div *ngIf="col.type === 'linked-tender'" class="linked-tender-cell">
          <div class="tender-title">{{ getFieldValue(row, col.field)?.title || '' }}</div>
          <a
            *ngIf="getFieldValue(row, col.field)?.tenderId"
            (click)="handleLinkClick(col.field, row)"
            class="tender-id-link"
            [class.disabled-link]="isRowDisabled(row)">
            {{ getFieldValue(row, col.field)?.tenderId || '' }}
          </a>
          <div *ngIf="!getFieldValue(row, col.field)?.tenderId" class="tender-id">{{ getFieldValue(row, col.field)?.tenderId || '' }}</div>
        </div>

        <!-- Action Type - Multiple Actions -->
        <div *ngIf="col.type === 'action' && col.actions && col.actions.length > 0" class="actions-column">
          <ng-container *ngFor="let action of col.actions; trackBy: trackByIndex">
            <label
              *ngIf="action.type === 'checkbox' && (!action.condition || action.condition(row))"
              class="action-checkbox action-switch"
              [title]="action.title"
              [attr.aria-label]="action.title"
              (click)="$event.stopPropagation()">
              <input
                type="checkbox"
                [checked]="!!getFieldValue(row, action.checkedField || action.action)"
                [disabled]="isRowDisabled(row)"
                (click)="handleCheckboxActionClick($event, action, row)"
                (change)="!isRowDisabled(row) && !action.preventToggleWhen?.(row) && handleActionClick(action.action, row, $any($event.target).checked)" />
              <span class="switch-track px-3 text-center" aria-hidden="true"><span class="switch-thumb"></span><span class="switch-track-text">{{action.title}}</span></span>
            </label>
            <button
              *ngIf="action.type !== 'checkbox' && (!action.condition || action.condition(row))"
              class="action-btn"
            [ngClass]="{
              'action-btn-with-text': action.showText,
              'icon-small': action.iconSize === 'small',
              'icon-medium': action.iconSize === 'medium' || !action.iconSize,
              'icon-large': action.iconSize === 'large'
            }"
            (click)="handleActionClick(action.action, row)"
            [title]="isRowDisabled(row) ? (getFieldValue(row, 'sealedBidMessage') || 'Bid is sealed') : action.title"
            [attr.aria-label]="action.title"
            [disabled]="isRowDisabled(row)">
            <!-- SVG String Icon -->
            <span *ngIf="action.icon && !action.iconPath" [innerHTML]="sanitizeIcon(action.icon)" class="action-icon"></span>
            <!-- Icon from File Path (SVG or PNG) -->
            <img *ngIf="action.iconPath" [src]="action.iconPath" [alt]="action.title" class="action-icon-img action-icon">
            <!-- Default Eye Icon if no icon specified and no text -->
            <svg *ngIf="!action.icon && !action.iconPath && !action.showText" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="action-icon">
              <path d="M1.3737 8.23224C1.31814 8.08256 1.31814 7.91792 1.3737 7.76824C1.91483 6.45614 2.83338 5.33427 4.01288 4.54484C5.19239 3.75541 6.57973 3.33398 7.99904 3.33398C9.41834 3.33398 10.8057 3.75541 11.9852 4.54484C13.1647 5.33427 14.0832 6.45614 14.6244 7.76824C14.6799 7.91792 14.6799 8.08256 14.6244 8.23224C14.0832 9.54434 13.1647 10.6662 11.9852 11.4556C10.8057 12.2451 9.41834 12.6665 7.99904 12.6665C6.57973 12.6665 5.19239 12.2451 4.01288 11.4556C2.83338 10.6662 1.91483 9.54434 1.3737 8.23224Z" stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <!-- Action Text -->
            <span *ngIf="action.showText" class="action-text">{{ action.title }}</span>
          </button>
          </ng-container>
        </div>

        <!-- Action Type - Single Action (backward compatibility) -->
        <div *ngIf="col.type === 'action' && (!col.actions || col.actions.length === 0)" class="actions-column">
          <button
            class="view-btn"
            (click)="handleActionClick(col.field, row)"
            [title]="isRowDisabled(row) ? (getFieldValue(row, 'sealedBidMessage') || 'Bid is sealed') : (col.actionTitle || 'View')"
            [attr.aria-label]="col.actionTitle || 'View'"
            [disabled]="isRowDisabled(row)">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M1.3737 8.23224C1.31814 8.08256 1.31814 7.91792 1.3737 7.76824C1.91483 6.45614 2.83338 5.33427 4.01288 4.54484C5.19239 3.75541 6.57973 3.33398 7.99904 3.33398C9.41834 3.33398 10.8057 3.75541 11.9852 4.54484C13.1647 5.33427 14.0832 6.45614 14.6244 7.76824C14.6799 7.91792 14.6799 8.08256 14.6244 8.23224C14.0832 9.54434 13.1647 10.6662 11.9852 11.4556C10.8057 12.2451 9.41834 12.6665 7.99904 12.6665C6.57973 12.6665 5.19239 12.2451 4.01288 11.4556C2.83338 10.6662 1.91483 9.54434 1.3737 8.23224Z" stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="#4A5565" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>

        <!-- Custom Type -->
        <span *ngIf="col.type === 'custom' && col.customTemplate" [innerHTML]="sanitizeIcon(col.customTemplate(row))"></span>
      </td>
    </tr>
  </ng-template>

  <!-- Empty State -->
  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="columns.length + (showCheckbox ? 1 : 0)" class="empty-message">
        <div class="empty-state">
          <i class="bi bi-inbox empty-icon"></i>
          <p>No data available</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<!-- Filter Dropdown Container (Outside Table) -->
<app-column-filter-dropdown
  *ngIf="openFilterColumnObj"
  [column]="openFilterColumnObj"
  [currentFilter]="getCurrentFilter(openFilterColumnObj)"
  [uniqueValues]="getUniqueValues(openFilterColumnObj)"
  [data]="data"
  [triggerElement]="filterTriggerElement"
  (filterApply)="onFilterApply(openFilterColumnObj, $event)"
  (filterClear)="onFilterClear(openFilterColumnObj)"
  (sortApply)="onSortApply(openFilterColumnObj, $event)"
  (closed)="onFilterDropdownClosed(openFilterColumnObj)">
</app-column-filter-dropdown>
